/*
Akhila 12/26/2022 3075154998 Added Add Rule Popup
Sohel 12/28/2022 3075154998 Condition Table Changes
Sohel 12/29/2022 3075154998 Condition Table Changes
Akhila 12/30/2022 3075154998 Added Condtion for empty Data in table
Sohel 01/02/2023 2698964415 pass condition deleted ids in payload
Sohel 01/13/2023 2698964415 resultExpression populate issue
Sohel 01/17/2023 2698964415 payload Changes
Sohel 01/17/2023 2698964415 change popup delete message
Sohel 01/24/2023 2698964415 removed space between Temp repo
Ravi 01/30/2023 2698964415 Fixed lebel condition issue
Sohel 01/03/2023 2700912712  data manager condition value changes
Dilip 03/28/2023 2700912712 Fixed delete id's in save api payload issue.
Akhila 04/24/2023 2700912712 bug fixed and prepoulated data
Sohel 10/10/2023 2700912712 Fixed Repository Name Space Issue
*/

import {IconButton, Tooltip} from '@material-ui/core';
import React, {useState, useRef} from 'react';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import PageLoader from '../../../../../components/PageLoader';
import {getDataManagerOptions as getOptions} from '../../../../../components/SqlRuleBuilder/utils';

const ConditionsTable = ({
  setFormData,
  formData,
  isEditMode,
  setIsEditMode,
  setRowData,
  setOldRuleCode,
  conditionalProps,
  conditionDeletedIds,
}) => {
  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'Condition Code',
    },
    {
      title: 'Field',
    },
    {
      title: 'Condition',
    },
    {
      title: 'Value',
    },
  ];

  const [isDelete, setIsDelete] = useState(false);
  const [loader, setLoader] = useState(false);
  const {value, handleValueChange, name} = conditionalProps;
  const isDataTransformation = ['Y', true]?.includes(value?.isDataTransformation) ? true : false;
  const conditionRule = useRef({});
  const conditionIndex = useRef();
  const handleSubmit = () => {
    setLoader(true);
    setTimeout(() => {
      const data = [...value.conditions];
      const newData = data.filter((row, i) => i !== conditionIndex.current);
      const key = conditionRule?.current?.processorCode;
      if (key && conditionDeletedIds.current?.[key]) {
        conditionDeletedIds.current[key] = [
          ...conditionDeletedIds.current[key],
          conditionRule?.current?.dmProcessorCondId,
        ];
      } else if (key) {
        conditionDeletedIds.current[key] = [conditionRule.current.dmProcessorCondId];
      }
      handleValueChange(`${name}.conditions`, newData);
      if (value?.resultExpCondition) {
        const result = newData.map((el, i) => el.ruleCode).join(` ${value.resultExpCondition} `);
        handleValueChange(`${name}.result`, result);
      }
      handleCloseDialog();
      setLoader(false);
    }, 1000);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  return (
    <>
      <div
        className={
          'mui-custom-table-container custom-table  pt-0 global-field-table text-center-table new-standard-textfields '
        }
      >
        <table>
          <thead className="recFormat-header-container">
            <tr>
              {columns.map(
                ({title, hidden = false}) =>
                  !hidden && (
                    <th key={title} className="recFormat-header">
                      {title}
                    </th>
                  ),
              )}
            </tr>
          </thead>
          <tbody className="recFormat-body">
            {value?.conditions?.length > 0 ? (
              value?.conditions?.map((el, index) => {
                return (
                  <tr key={index}>
                    <td className="recFormat-col recFormat-center">
                      <Tooltip title="Edit">
                        <IconButton
                          disabled={isDataTransformation}
                          onClick={(e) => {
                            setIsEditMode(true);
                            setRowData(el);
                            setOldRuleCode(el.ruleCode);
                          }}
                        >
                          <EditOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          disabled={isDataTransformation}
                          onClick={(e) => {
                            setIsDelete(true);
                            conditionRule.current = el;
                            conditionIndex.current = index;
                          }}
                        >
                          <DeleteOutlined />
                        </IconButton>
                      </Tooltip>
                    </td>
                    <td className="recFormat-col recFormat-center">
                      {el?.ruleCode ? el?.ruleCode : el?.conditionCode ? el?.conditionCode : ''}
                    </td>
                    <td className="recFormat-col recFormat-center">
                      {el?.selectField?.repositoryName ?
                        el?.selectField?.repositoryName +
                          '.' +
                          el?.selectField?.fieldName :
                        el?.field2RepositoryName ?
                          el?.field2RepositoryName + '.' + el?.field2Name :
                          ''}
                    </td>
                    <td className="recFormat-col recFormat-center">
                      {' '}
                      {
                        getOptions(el?.selectField?.dataType?.toLowerCase())?.filter(
                          (e) => e.value === el?.condition,
                        )[0]?.label
                      }
                    </td>
                    <td className="recFormat-col recFormat-center">
                      {el?.expression ?
                        el?.expression :
                        el?.rhsRuleExpression ?
                          el?.rhsRuleExpression :
                          ''}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length}>
                  No records to display. To add Condition Fields to your PreProcessor click the &quot;+
                  Add Condition&quot; button in the top right of this section.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Condition"
        value={`Are you sure you want to delete this ${
          conditionRule.current?.selectField?.repositoryName +
          '.' +
          conditionRule.current?.selectField?.fieldName
        } Condition : ${conditionRule.current?.ruleCode}?`}
        handleSubmit={handleSubmit}
      />
      {loader && <PageLoader />}
    </>
  );
};

export default ConditionsTable;
